import { SimpleHeroStoryblok } from "@/generated/sb/sb-types";

import BlokWrap from "@/components/ui/BlokWrap";
import { AnimationType } from "@/components/ui/BlokWrap/BlokWrap";
import { BlokProps, StoryblokComponent } from "@frend-digital/storyblok";
import clsx from "clsx";
import { CompWrapper } from "./CompWrapper";
import styles from "./index.module.css";

export const SimpleHeroBlok = ({
  blok,
  preview,
  animation,
}: BlokProps<SimpleHeroStoryblok> & {
  animation?: AnimationType;
}) => {
  const { title } = blok;
  const getColorProps = () => {
    if ("titleColor" in blok) {
      const blokToUse = blok as typeof blok & {
        titleColor: {
          color: string;
        };
      };

      if (!blokToUse.titleColor.color) return {};

      return {
        style: {
          color: blokToUse.titleColor.color,
        },
      };
    }
    return {};
  };

  return (
    <BlokWrap
      data-layout="page"
      editable={blok}
      animated={animation}
      className={clsx(styles.hero, "hero")}
    >
      <CompWrapper link={blok.link}>
        {blok.media && (
          <StoryblokComponent preview={preview} blok={blok.media[0]} />
        )}

        {title && (
          <div className={clsx(styles.content)}>
            <h2 {...getColorProps()} className={clsx(styles.title)}>
              {title}
            </h2>
          </div>
        )}
      </CompWrapper>
    </BlokWrap>
  );
};
